import { lazy, Suspense } from "react";
import { createFileRoute } from "@tanstack/react-router";

// The store editor bundles the whole block editor; load it on demand.
const StoreEditor = lazy(() => import("@/components/admin/StoreEditorPanel"));

function EditorRouteComponent() {
  return (
    <Suspense
      fallback={<div className="p-10 text-center text-sm text-[#2C2C2C]/60">Loading editor…</div>}
    >
      <StoreEditor />
    </Suspense>
  );
}

export const Route = createFileRoute("/_authenticated/admin_/editor")({
  component: EditorRouteComponent,
  errorComponent: () => (
    <div className="p-10 text-center text-sm text-[#2C2C2C]">
      The editor didn’t load. Refresh the page to try again.
    </div>
  ),
  notFoundComponent: () => <div className="p-10 text-center text-sm">Not found</div>,
});
